import { gql, useQuery } from "@apollo/client";

import { useUser } from "../useUser";

const superadminPermissionProbeQuery = gql`
  query SuperadminPermissionProbe {
    superadminSiteSettings {
      disableSmsVerification
    }
  }
`;

interface SuperadminPermissionProbeData {
  superadminSiteSettings: {
    disableSmsVerification: boolean;
  } | null;
}

export const useIsSuperAdmin = () => {
  const { authenticated } = useUser();
  const { data } = useQuery<SuperadminPermissionProbeData>(superadminPermissionProbeQuery, {
    skip: !authenticated,
    fetchPolicy: "cache-first",
    errorPolicy: "ignore",
  });

  return Boolean(data?.superadminSiteSettings);
};
